export default __webpack_public_path__ + "static/alex-4134efc27f7bafdb3db8e411e65bedb3.svg";